
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
// The '!!raw-loader!' syntax is a non-standard, Webpack-specific, syntax.
// See: https://github.com/webpack-contrib/raw-loader#examples
// For now, it seems likely Storybook is pretty tied to Webpack, therefore, we are
// okay with the following Webpack-specific raw loader syntax. It's better to leave
// the ESLint rule enabled globally, and only thoughtfully disable as needed (e.g.
// within a Storybook docs page and not within an actual component).
// This can be revisited in the future if Storybook no longer relies on Webpack.
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import noWrapDemoSource from '!!raw-loader!./demo/nowrap.twig';
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import colorDemoSource from '!!raw-loader!./demo/color.twig';
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import textAlignDemoSource from '!!raw-loader!./demo/text-align.twig';
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import sizeDemoSource from '!!raw-loader!./demo/size.twig';
import noWrapDemo from './demo/nowrap.twig';
import colorDemo from './demo/color.twig';
import textAlignDemo from './demo/text-align.twig';
import sizeDemo from './demo/size.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Utilities/Text" mdxType="Meta" />
    <h1>{`Text`}</h1>
    <p>{`Utilities for controlling text properties.`}</p>
    <h2>{`White-space nowrap`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`u-text-no-wrap`}</inlineCode></li>
    </ul>
    <p>{`Utility for controlling the white-space wrapping of text, applies `}<inlineCode parentName="p">{`white-space: nowrap`}</inlineCode>{`.`}</p>
    <p>{`Notice in the second example how the `}<inlineCode parentName="p">{`some-long-text`}</inlineCode>{` text doesn't wrap.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="White-space nowrap" parameters={{
        docs: {
          source: {
            code: noWrapDemoSource
          }
        }
      }} mdxType="Story">
    {args => noWrapDemo(args)}
  </Story>
    </Canvas>
    <h2>{`Action text`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`u-text-action`}</inlineCode></li>
    </ul>
    <p>{`Utility that changes the text color to the "action" text color.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Action text" parameters={{
        docs: {
          source: {
            code: colorDemoSource
          }
        }
      }} mdxType="Story">
    {args => colorDemo(args)}
  </Story>
    </Canvas>
    <h2>{`Text-align center`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`u-text-center`}</inlineCode></li>
    </ul>
    <p>{`Utility that sets `}<inlineCode parentName="p">{`text-align`}</inlineCode>{` to `}<inlineCode parentName="p">{`center`}</inlineCode></p>
    <Canvas mdxType="Canvas">
  <Story name="Text-align center" parameters={{
        docs: {
          source: {
            code: textAlignDemoSource
          }
        }
      }} mdxType="Story">
    {args => textAlignDemo(args)}
  </Story>
    </Canvas>
    <h2>{`Size`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`u-text-big`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`u-text-small`}</inlineCode></li>
    </ul>
    <p>{`These utility classes provide some opinionated size adjustments to bump an element's font size up or down a notch. At narrower viewports, the difference is little to none: Paragraphs of "big" text could easily overwhelm the visible area, and paragraphs of "small" text would cause eye strain and poor accessibility. As the viewport and base font size increase, the difference becomes more noticeable.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Big and small" parameters={{
        docs: {
          source: {
            code: sizeDemoSource
          }
        }
      }} mdxType="Story">
    {args => sizeDemo(args)}
  </Story>
    </Canvas>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const whiteSpaceNowrap = (args => noWrapDemo(args));
whiteSpaceNowrap.storyName = 'White-space nowrap';
whiteSpaceNowrap.parameters = { storySource: { source: 'args => noWrapDemo(args)' }, ...{
  docs: {
    source: {
      code: noWrapDemoSource
    }
  }
} };

export const actionText = (args => colorDemo(args));
actionText.storyName = 'Action text';
actionText.parameters = { storySource: { source: 'args => colorDemo(args)' }, ...{
  docs: {
    source: {
      code: colorDemoSource
    }
  }
} };

export const textAlignCenter = (args => textAlignDemo(args));
textAlignCenter.storyName = 'Text-align center';
textAlignCenter.parameters = { storySource: { source: 'args => textAlignDemo(args)' }, ...{
  docs: {
    source: {
      code: textAlignDemoSource
    }
  }
} };

export const bigAndSmall = (args => sizeDemo(args));
bigAndSmall.storyName = 'Big and small';
bigAndSmall.parameters = { storySource: { source: 'args => sizeDemo(args)' }, ...{
  docs: {
    source: {
      code: sizeDemoSource
    }
  }
} };

const componentMeta = { title: 'Utilities/Text', includeStories: ["whiteSpaceNowrap","actionText","textAlignCenter","bigAndSmall"],  };

const mdxStoryNameToKey = {"White-space nowrap":"whiteSpaceNowrap","Action text":"actionText","Text-align center":"textAlignCenter","Big and small":"bigAndSmall"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;